import type { WorkflowActionType, WorkflowTriggerType } from '../../lib/workflows-api'

/** Human labels for trigger types (UI only; the API allowlist is authoritative). */
export const TRIGGER_LABELS: Record<string, string> = {
  manual: 'Manual / test only',
  'signup.created': 'A signup is created',
  'list.member_added': 'Someone is added to a list',
  'form.submitted': 'A form is submitted',
  schedule: 'On a schedule',
}

export const TRIGGER_OPTIONS: { value: WorkflowTriggerType; label: string }[] = [
  { value: 'signup.created', label: TRIGGER_LABELS['signup.created']! },
  { value: 'list.member_added', label: TRIGGER_LABELS['list.member_added']! },
  { value: 'form.submitted', label: TRIGGER_LABELS['form.submitted']! },
  { value: 'schedule', label: TRIGGER_LABELS.schedule! },
  { value: 'manual', label: TRIGGER_LABELS.manual! },
]

export const ACTION_LABELS: Record<string, string> = {
  add_to_list: 'Add person to a list',
  remove_from_list: 'Remove person from a list',
  update_person_field: 'Update a person field',
  send_notification: 'Send a notification',
  webhook: 'Call a webhook',
}

export const ACTION_OPTIONS: { value: WorkflowActionType; label: string }[] = [
  { value: 'add_to_list', label: ACTION_LABELS.add_to_list! },
  { value: 'remove_from_list', label: ACTION_LABELS.remove_from_list! },
  { value: 'update_person_field', label: ACTION_LABELS.update_person_field! },
  { value: 'send_notification', label: ACTION_LABELS.send_notification! },
  { value: 'webhook', label: ACTION_LABELS.webhook! },
]

/** A sensible empty config for a freshly-added action of each type. */
export function defaultActionConfig(type: WorkflowActionType): Record<string, unknown> {
  switch (type) {
    case 'add_to_list':
    case 'remove_from_list':
      return { listId: '' }
    case 'update_person_field':
      return { field: 'membershipStatus', value: 'member' }
    case 'send_notification':
      return { message: '' }
    case 'webhook':
      return { url: '' }
    default:
      return {}
  }
}
